import React from 'react';
import styled from 'styled-components';
import VideoPlayer from './VideoPlayer'; // ← import the new component

const VideoSectionContainer = styled.section`
  padding: 40px 20px;
  background: var(--gray);
  text-align: center;

  h2 {
    font-size: 2.5rem;
    margin-bottom: 30px;
    color: var(--light);
  }
`;

const VideoSection = ({ src, title, subheader, isEmbed = true }) => {
  return (
    <VideoSectionContainer>
      <h2>{title}</h2>
      {subheader && <p style={{ color: 'rgba(255,255,255,0.7)', marginBottom: '20px' }}>{subheader}</p>}
      <VideoPlayer src={src} title={title} isEmbed={isEmbed} />
    </VideoSectionContainer>
  );
};

export default VideoSection;